angular.module("ngSentry", []);
Sentry.init({
  dsn: "https://878ad89e5baa4a389f6ce8d8efe80746@o133707.ingest.sentry.io/6169273",
  integrations: [new Sentry.Integrations.Angular()],
  tracesSampleRate: 1.0,
});
